import React from "react";

const LoadingIndicator = () => {
  return (
    <div className=" x flex justify-center items-center h-screen">
      <div className="animate-spin rounded-full h-32 w-32 border-t-2 border-b-2 border-[#FFB830]"></div>
      <p className="text-center text-lg font-semibold text-custom-maroon">
        Loading...
      </p>
      <div className="animate-ping rounded-full h-32 w-32 border-t-2 border-b-2 border-[#FFB830]"></div>
    </div>
  );
};

export default LoadingIndicator;
